<template>
  <div class="blank">
    <choose-community v-if="isShowChooseCommunity" @selected="initMenuList"></choose-community>
  </div>
</template>

<script>
  import RouteService from '@/io/route.js'; 
  import UserService from '@/io/user.js';
  import ChooseCommunity from '@/views/common/ChooseCommunity.vue';

  export default {
    name: 'Blank',
    data() {
      return {
        redirectUrl: null,
        isShowChooseCommunity: false
      }
    },
    mounted () {
      this.initUserInfo().then(() => {
        if (this.isPlatformRole) {
          this.initMenuList();
        } else {
          this.isShowChooseCommunity = true;
        }
      });
    },
    components: {
      ChooseCommunity,
    },
    methods: {
      initUserInfo() {
        let hideLoading = this.$message.loading({content: '初始化管理员信息', duration: 0});
        return UserService.userInfo().then(res => {
          this.$store.commit('setUserInfo', res);
        }).catch(err => {}).finally(() => {
          hideLoading();
        });
      },
      initMenuList() {
        if (this.$store.state.userInfo) {
          let hideLoading = this.$message.loading({content: '初始化管理员菜单', duration: 0});
          return UserService.menuList(this.isPlatformRole).then(res => {
            this.$store.commit('setMenuList', res);
            this.initRoute(res);
            this.$router.replace(this.$store.state.redirectUrl || this.redirectUrl);
          }).catch(err => {}).finally(() => {
            hideLoading();
          });
        }
      },
      formatRoute(path) {
        return path.replace('platform/', '').replace('community/', '');
      },
      initRoute() {
        let rootRoute = this.$store.state.menuList[0];
        let routes = [];
        this.$depthSearchTree(node => {
          if (node.path) {
            // 访问地址
            let rootPath = rootRoute.path;
            if (!this.isPlatformRole) {
              rootPath = rootRoute.path.replace(':community_id', this.$getCookie('communityId'));
            }
            node.url = `${rootPath}/${node.path}`;
            // 空路由默认跳转
            if (!this.redirectUrl) {
              this.redirectUrl = node.url;
            }
            // 初始化路由
            routes.push(this.initRouteItem(node.path, this.formatRoute(node.name), this.loadPage(node.component), null, {
              title: node.title,
              path: this.createPath(node.parent_id),
              noBack: true,
              keepAlive: true
            }, null));
            // 初始化关联子路由
            if (RouteService[node.name]) {
              RouteService[node.name].forEach(val => {
                routes.push(this.initRouteItem(val.path, val.name, val.component, val.children, {
                  ...val.meta,
                  path: this.createPath(node.id)
                }, val.redirect));
              });
            }
          }
        }, rootRoute.children);
        this.initRouter([this.initRouteItem(rootRoute.path, this.formatRoute(rootRoute.name), this.loadPage(rootRoute.component), routes, null, null)]);
      },
      createPath(id, sourceData) {
        let result = [];
        let func = (m, n) => {
          this.$depthSearchTree(node => {
            if (node.id === m) {
              result.push(node);
              func(node.parent_id);
            }
          }, n || this.$store.state.menuList);
        }
        func(id, sourceData);
        return result
      },
      loadPage(name) {
        return () => import(`@/views/${name}.vue`);
      },
      initRouteItem(path, name, component, children, meta, redirect) {
        return {
          path,
          name,
          component,
          children,
          meta,
          redirect
        }
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .blank {
    .choose-community {
      width: 400px;
      margin: 0 auto;
      padding: @padding-lg 0;
    }
  }
</style>